// extracted by mini-css-extract-plugin
export default {"button":"BackLink_button__8Hmcp"};